import * as Icon from 'base/ui/components/Icons';

import { Form, Modal, Select, message } from 'antd';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { commonMasterDataPresenter, commonMasterDataStore, districtPresenter, districtStore, userStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTION, SYSTEM_TITLE } from 'utils/constants';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { ProColumns } from '@ant-design/pro-components';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomBreadcrumb from 'base/ui/components/CustomBreadcrumb';
import CustomInput from 'base/ui/components/CustomInput';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import { usePermission } from 'hooks/usePermission';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { HiSearch } from 'react-icons/hi';
import { District } from 'services/RawData/district_services';
import { dropdownStatus } from 'utils/dropdown';
import { removeEmptyValues } from 'utils/transformHelper';

const { confirm } = Modal;

const districtPage = () => {
  return observer(() => {
    usePermission('INDEX'); // Kiểm tra xem được quyền truy cập vào trang

    // translate en/vn
    const { t } = useTranslation();
    const pagetitle = t('masterdata.district.title');
    document.title = pagetitle + ' - ' + SYSTEM_TITLE;
    const navigate = useNavigate();
    const [form] = Form.useForm();
    // state ===============================================================================
    const [openDrawer, setOpenDrawer] = useState(false);

    // Columns table title
    const defaultColumn: ProColumns<District>[] = [
      {
        title: t('masterdata.district.stt'),
        dataIndex: 'stt',
        key: 'stt',
        width: 60,
        align: 'center',
        className: '!rounded-none !py-1',
        render: (text) => <div className="!text-center">{text}</div>,
        fixed: 'left',
      },
      // Tỉnh/Thành phố
      {
        title: t('masterdata.district.province'),
        dataIndex: 'provinceName',
        key: 'provinceName',
        width: 100,
        className: '!rounded-none !py-1',
        fixed: 'left',
      },
      // Mã quận huyện
      {
        title: t('masterdata.district.district-code'),
        dataIndex: 'districtCode',
        key: 'districtCode',
        width: 100,
        className: '!rounded-none !py-1',
        fixed: 'left',
        render: (text, record) => {
          return <Link to={`/MasterData/District/${record.districtId}`}>{record.districtCode}</Link>;
        },
      },
      // Tên quận huyện
      {
        title: t('masterdata.district.district-name'),
        dataIndex: 'districtName',
        key: 'districtName',
        width: 100,
        className: '!rounded-none !py-1',
      },
      // Trạng thái
      {
        title: t('masterdata.district.status'),
        dataIndex: 'actived',
        width: 100,
        key: 'actived',
        align: 'center',
        render: (text) => (
          <div className="w-full flex justify-center">
            {text ? (
              <Icon.CheckStatus className="!fill-[#389e0d]" width="15" />
            ) : (
              <Icon.CloseStatus width="15" className="!fill-red-500" />
            )}
          </div>
        ),
      },
      // // Chức năng
      // {
      //   title: t('masterdata.district.actions'),
      //   dataIndex: 'actions',
      //   key: 'actions',
      //   width: 100,
      //   className: '!rounded-none !py-1',
      //   align: 'center',
      //   hideInTable:
      //     userStore.userPermission?.includes('EDIT') && userStore.userPermission?.includes('DELETE') ? true : false,
      //   render: (_, record) => {
      //     return (
      //       <div className="w-full flex items-center justify-center gap-x-1">
      //         {userStore.userPermission?.includes('EDIT') ? (
      //           <CustomButtonIcon color="#007BF1" onClick={() => navigate(`${record.districtId}`)}>
      //             <Icon.PencilEdit className="!fill-[#007BF1]" width="14" height="14" />
      //           </CustomButtonIcon>
      //         ) : null}
      //         {userStore.userPermission?.includes('DELETE') ? (
      //           record.actived ? (
      //             <CustomButtonIcon
      //               color="#FC5C5E"
      //               onClick={() => {
      //                 showDeleteConfirm(record);
      //               }}
      //             >
      //               <Icon.Trash className="!fill-[#FC5C5E]" width="14" height="14" />
      //             </CustomButtonIcon>
      //           ) : (
      //             <CustomButtonIcon color="#fff00" className="border-none outline-none cursor-default">
      //               <Icon.Trash className="!fill-transparent" width="14" height="14" />
      //             </CustomButtonIcon>
      //           )
      //         ) : null}
      //       </div>
      //     );
      //   },
      // },
    ];
    // Loading all page
    const [loading, setLoading] = useState(false);

    // Data search
    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        orderBy: '',
        orderByDesc: '',
      },
    });

    // List data table
    const [listDistrict, setListDistrict] = useState<District[]>([]);

    // const [selected, setSelected] = useState('Export');
    // const items: MenuProps['items'] = [
    //   {
    //     label: (
    //       <Link onClick={(e) => setSelected(e.currentTarget.textContent || '')} to={'/Form/Customer'}>
    //         Mẫu thêm mới
    //       </Link>
    //     ),
    //     key: '0',
    //   },
    //   {
    //     label: (
    //       <Link onClick={(e) => setSelected(e.currentTarget.textContent || '')} to={'/Form/Customer'}>
    //         Mẫu cập nhật
    //       </Link>
    //     ),
    //     key: '1',
    //   },
    // ];
    // function open hide drawer ===========================================================

    const showDrawer = () => {
      setOpenDrawer(true);
    };

    const onCloseDrawer = () => {
      setOpenDrawer(false);
    };

    // Ui modal confirm delete store ================================================================
    const showDeleteConfirm = (item: District) => {
      confirm({
        title: `Xoá quận huyện`,
        icon: <ExclamationCircleFilled />,
        content: `${t('message.question-delete')} "${item.districtName}"`,
        okText: t('btn.delete'),
        okType: 'danger',
        cancelText: t('btn.cancel'),
        className: 'custom__modalconfirm--delete',
        onOk() {
          handleClickDelete(item.districtId);
        },
        onCancel() { },
      });
    };
    // Call api delete
    const handleClickDelete = async (id?: string) => {
      setLoading(true);
      if (id) {
        await districtPresenter.deleteDistrict(districtStore, id);
        if (districtStore.crudResponse.isSuccess) {
          message.success(districtStore.crudResponse.message);
          // Call list branch after change
          await getDataSearchListDistrict(dataSearch);
        } else {
          message.error(districtStore.crudResponse.message);
        }
      }
      setLoading(false);
    };

    // Call api data search
    const getDataSearchListDistrict = async (dataSearch: object) => {
      await districtPresenter.searchListDistrict(districtStore, dataSearch);
      if (districtStore.listDistrict.isSuccess) {
        setListDistrict(districtStore.listDistrict.data);
      }
    };

    // Handle click button search
    const handleSearch = async (values: any) => {
      setLoading(true);
      const tempDataSearch = {
        paging: {
          ...dataSearch.paging,
          pageIndex: 1,
        },
        ...values,
      };
      removeEmptyValues(tempDataSearch);
      // set pageIndex 1 when search form
      setDataSearch(tempDataSearch);

      await getDataSearchListDistrict(tempDataSearch);
      setLoading(false);
      onCloseDrawer();
    };

    useEffect(() => {
      (async () => {
        await commonMasterDataPresenter.getDropDownProvince(commonMasterDataStore);
      })();
    }, []);

    // scroll to top
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    return (
      <div className="w-full">
        {/* ==================================== Breadcrumb ========================================= */}
        <CustomBreadcrumb
          pagetitle={[{ title: pagetitle, link: 'District' }]}
          extra={
            <>
              <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
                <Icon.Filter className="fill-primary" />
              </CustomButton>
              {userStore.userPermission?.includes('CREATE') ? (
                <CustomButton
                  onClick={() => {
                    navigate('create');
                  }}
                  type="primary"
                  icon={<Icon.Plus className="!fill-[#fff]" />}
                >
                  {t('btn.add')}
                </CustomButton>
              ) : null}
              {/* {userStore.userPermission?.includes('EXPORT') ? (
                <CustomButton>
                  <Dropdown menu={{ items }} trigger={['click']}>
                    <Space className="cursor-pointer h-[46px]">
                      <span>
                        <Icon.Download className={'!fill-dark'} />
                      </span>
                      <span className={`text-dark font-[400] text-[14px] leading-[22px]`}>{selected}</span>
                      <span>
                        <Icon.ChevronDown className={'!fill-dark'} />
                      </span>
                    </Space>
                  </Dropdown>
                </CustomButton>
              ) : null}
              {userStore.userPermission?.includes('IMPORT') ? (
                <CustomButton icon={<Icon.Upload />}>Import</CustomButton>
              ) : null} */}
            </>
          }
        />
        {/* Table */}
        <BoxContainer>
          <CustomProTable<District>
            columns={defaultColumn}
            handleResize={() => { }}
            rowKey="stt"
            size="small"
            bordered
            search={false}
            loading={loading}
            request={async (params = {}, sort, filter) => {
              setLoading(true);
              const values = form.getFieldsValue();
              const data: any = await getDataSearchListDistrict({
                ...values,
                paging: {
                  ...dataSearch.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                },
              });

              if (Object.values(sort).length) {
                setDataSearch({
                  paging: {
                    ...dataSearch.paging,
                    orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  },
                });
              }
              setLoading(false);
              return {
                data: data,
                success: districtStore.listDistrict.isSuccess,
              };
            }}
            dataSource={listDistrict}
            scroll={{ x: true }}
            pagination={{
              pageSize: dataSearch.paging.pageSize,
              total: districtStore.listDistrict.paging?.recordsTotal,
              current: dataSearch.paging.pageIndex,
              responsive: true,
              position: ['topRight', 'bottomRight'],
              style: { margin: '10px 0' },
              showSizeChanger: false,
              showTotal: (total, range) => (
                <>
                  <span className="!absolute left-1">
                    {t('message.view')}{' '}
                    <CustomSelect
                      size="middle"
                      className="min-w-[72px] !rounded-none"
                      value={String(dataSearch.paging.pageSize)}
                      onChange={(value) => {
                        setDataSearch({
                          ...dataSearch,
                          paging: { ...dataSearch.paging, pageSize: Number(value) },
                        });
                      }}
                    >
                      {PAGE_SIZE_OPTION.map((pageSize) => (
                        <Select.Option key={pageSize} value={String(pageSize)}>
                          {pageSize}
                        </Select.Option>
                      ))}
                    </CustomSelect>{' '}
                    {t('message.item')}
                  </span>
                  <span className="hidden md:block">{`${t('message.display')} ${range[0]}-${range[1]} ${t(
                    'message.of',
                  )} ${total} ${t('message.entries')}`}</span>{' '}
                </>
              ),
              onChange: (page, pageSize) => {
                setDataSearch({
                  ...dataSearch,
                  paging: { ...dataSearch.paging, pageIndex: page, pageSize: pageSize },
                });
              },
            }}
            options={false}
          />
        </BoxContainer>

        {/* form tìm kiếm */}
        <SearchBox
          className="lg:!w-[35%]"
          footer={[
            <div key="footer" className="flex justify-end">
              <CustomButton
                type="primary"
                icon={<HiSearch />}
                htmlType="submit"
                onClick={() => {
                  form.submit();
                  onCloseDrawer();
                }}
              >
                {t('btn.search')}
              </CustomButton>
            </div>,
          ]}
          onClose={onCloseDrawer}
          open={openDrawer}
        >
          <SearchForm column="col-1" form={form} onFinish={handleSearch} layout="vertical">
            {/* Tỉnh/thành phố */}
            <SearchItem label={t('masterdata.district.province')} name={'provinceId'}>
              <CustomSelect
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                options={commonMasterDataStore.provinceDropdown.data.map((item) => {
                  return {
                    label: item.value,
                    value: item.key,
                  };
                })}
                className="!rounded-none"
              />
            </SearchItem>
            {/* Tên quận huyện */}
            <SearchItem label={t('masterdata.district.district-name')} name={'districtName'}>
              <CustomInput className="!rounded-none" />
            </SearchItem>
            {/* Trạng thái */}
            <SearchItem label={t('masterdata.district.status')} name={'actived'}>
              <CustomSelect options={dropdownStatus} placeholder={t('place-holder.all')} allowClear />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </div>
    );
  });
};

export default districtPage;
